import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function treatmentDateValidator(dateKey: string, frequencyKey: string, errorPrefix: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const dateValue = group.get(dateKey)?.value;
    if (!dateValue) {
      return null;
    }

    const date = new Date(dateValue);
    date.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (date < today) {
      return { [`${errorPrefix}InPast`]: true };
    }

    const frequency = Number(group.get(frequencyKey)?.value);
    if (frequency) {
      const maxDate = new Date(today);
      maxDate.setMonth(maxDate.getMonth() + frequency);
      if (date > maxDate) {
        return { [`${errorPrefix}TooFarInFuture`]: true };
      }
    }

    return null;
  };
}
